function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M219.2,231H23.7c-6.4,0-11.7-5.3-11.7-11.7V23.7C12,17.3,17.3,12,23.7,12h46.9c6.4,0,11.7,5.3,11.7,11.7v76.2 C127,50.4,191.9,19.3,264.1,19.8c133.6,1,240.5,108.9,240.3,242.6C504,395.9,395.7,504,262.2,504c-62.6,0-119.6-23.7-162.5-62.7 c-5-4.5-5.2-12.3-0.5-17l33.2-33.2c4.4-4.4,11.4-4.6,16-0.5c30.3,26.8,70.2,43.1,113.8,43.1c95,0,171.8-76.8,171.8-171.8 S357.2,90.1,262.2,90.1c-57.1,0-107.7,27.8-138.9,70.6h96c6.4,0,11.7,5.3,11.7,11.7v46.9C231,225.8,225.8,231,219.2,231L219.2,231z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M258,254.4v11.2h-44.8v0.3l8,7.4c21,20.2,34.3,35.1,34.3,53.5c0,14.3-9,29-30.5,29c-11.5,0-21.3-4.3-28.2-10.1 l4.3-9.5c4.6,3.8,12.2,8.4,21.2,8.4c14.9,0,19.8-9.4,19.8-19.5c-0.1-15-11.6-27.9-37.1-52.1l-10.6-10.3v-8.3H258z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M283.6,328.6l-14.9,0.1l25.1-36.3l-26.4-37.9h14.9l10.7,16.7c2.7,4.5,5.3,8.5,7.8,12.9h0.3 c2.6-4.5,5.1-8.6,8-12.9l10.9-16.7h15.4l-26.1,38.3l25.3,35.9H320l-10.4-15.8c-2.5-4-4.9-7.9-7.4-12.3h-0.5 c-2.4,4.1-4.7,8-7.5,12.1L283.6,328.6L283.6,328.6z"
}));

function SvgIconRotateLeft2XMirroredMirrored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateLeft2XMirroredMirrored);
export default __webpack_public_path__ + "static/media/icon_rotate_left-2x-mirrored-mirrored.d650998a.svg";
export { ForwardRef as ReactComponent };